import React, { Component } from 'react';
import { dateSortMethod } from 'Common/GridHelper';
import { PACK_SIZE_MESSAGE } from 'Common/Constants/inventory';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import ReactTable from 'Common/ReactTableWrapper';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { ToolTipComponent } from 'Components';
import { FifoEnum } from 'Common/FieldEnum';

class FIFOTable extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        Header: 'Site Id',
        accessor: FifoEnum.SiteId,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Receipt Date',
        accessor: FifoEnum.ReceiptDT,
        sortMethod: dateSortMethod,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Purchase Qty',
        accessor: FifoEnum.PrimaryQty,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Unit',
        accessor: FifoEnum.Unit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Pack Qty',
        accessor: FifoEnum.SecondaryQty,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Pack Unit',
        accessor: FifoEnum.SecondaryUnit,
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: () => {
          return (
            <ToolTipComponent
              label={'Pack Size'}
              popMessage={PACK_SIZE_MESSAGE}
              iconName="question circle outline"
            />
          );
        },
        accessor: FifoEnum.QtyPerUnit,
        className: 'right-align',
        visibilityName: 'Pack Size',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'Price',
        accessor: FifoEnum.Price,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        Header: 'On Hand Value',
        accessor: FifoEnum.Value,
        className: 'right-align',
        ...ReactTableWrapperColumnProperties,
      },
      {
        width: 50,
        sortable: false,
      },
    ];
  }

  render() {
    const {
      fetchingFifo,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      reactTableRef,
      fifoItemsData,
      resetPageOnDataChange,
      onResetPageOnDataChange,
    } = this.props;

    return (
      <ReactTable
        reactTableRef={reactTableRef}
        defaultPageSize={20}
        showPageSizeOptions={true}
        minRows={5}
        data={fifoItemsData}
        resizable={false}
        className="-striped -highlight modalGrid"
        loading={
          fetchingFifo || gridPreferenceLoading || gridPreferenceSubmitting
        }
        columns={this.columns}
        draggableColumns={true}
        showHideColumn={true}
        menu={'hasCogs'}
        saveState={{ tableName: TableNamesEnum.FIFO_TABLE }}
        resetPageOnDataChange={resetPageOnDataChange}
        onResetPageOnDataChange={onResetPageOnDataChange}
        gridName={GridEnum.INV_FIFO_View}
      />
    );
  }
}

export { FIFOTable };



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/components/tables/FIFOTable.js